import {
    REPORTSUBJECT_RESET,
    REPORTSUBJECTS_RESET,
    REPORTSUBJECT_FOCUS,
    REPORTSUBJECT_DOWNLOADED,
    REPORTSUBJECTS_DOWNLOADED,
    REPORTSUBJECTS_PENDING,
    REPORTSUBJECTS_FAILED,
    REPORTSUBJECT_FAILED,
    REPORTSUBJECT_POSTING,
    REPORTSUBJECT_EDITING,
    REPORTSUBJECT_DELETED,
    REPORTSUBJECT_DELETING,
    REPORTSUBJECT_PICTURE_UPLOADING,
    REPORTSUBJECT_PICTURE_UPLOADED,
    REPORTSUBJECT_PICTURE_FAILED,
    REPORTSUBJECT_PICTURE_DELETING
} from './types';

export const INITIAL_STATE = {
    error: null,
    content: [],
    currentIndex: null,
    currentSubject: null,
    pending: false,
    sending: false
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case REPORTSUBJECT_RESET:
            return {
                ...state,
                error: null,
                currentIndex: 0,
                sending: false,
                currentSubject: null
            };
        case REPORTSUBJECT_DELETED:
            let newState = {
                ...state,
                sending: false
            };

            newState.content = state.content.filter((reportsubject)  => {
                return reportsubject.id !== action.payload
            });

            if (state.currentSubject) {
                if (state.currentSubject.id === action.payload) {
                    newState.currentSubject = null;
                    newState.currentIndex = null;
                } else {
                    newState.currentIndex = newState.content.findIndex((reportsubject) => {
                        return newState.currentSubject.id === reportsubject.id
                    });
                }
            }

            return newState;
        case REPORTSUBJECTS_RESET:
            return INITIAL_STATE;
        case REPORTSUBJECTS_PENDING:
            return {
                ...state,
                pending: true
            };
        case REPORTSUBJECT_FOCUS:
            return {
                ...state,
                error: null,
                currentIndex: state.content.findIndex(reportsubject => {
                    return reportsubject.id === action.payload.id
                }),
                currentSubject: action.payload
            };
        case REPORTSUBJECT_DOWNLOADED:
            let newContent = [];
            let newIndex;
            let id = action.payload.id;
            let reportsubject = state.content.find(function (reportsubject) {
                return reportsubject.id === id
            });

            if (reportsubject) {
                let index = state.content.findIndex(stateApp => {
                    return stateApp.id === reportsubject.id
                });
                newContent = state.content;
                newContent[index] = action.payload;
                newIndex = index;
            } else {
                newContent = [
                    ...state.content,
                    action.payload
                ];
                newIndex = newContent.length - 1;
            }

            return {
                ...state,
                pending: false,
                sending: false,
                error: null,
                content: newContent,
                currentSubject: action.payload,
                currentIndex: newIndex
            };
        case REPORTSUBJECTS_DOWNLOADED:
            let newAppDownloadedState = {
                ...state,
                pending: false,
                sending: false,
                error: null,
                content: action.payload,
            };

            if (state.currentSubject) {
                let newcurrentSubject = state.content.find(function (reportsubject) {
                    return reportsubject.id === state.currentSubject.id
                });
                if (newcurrentSubject) {
                    newAppDownloadedState.currentSubject = newcurrentSubject;
                    newAppDownloadedState.currentIndex = newAppDownloadedState.content.findIndex((reportsubject) => {
                        return newcurrentSubject.id === reportsubject.id
                    });
                }
            } else {
                newAppDownloadedState.currentSubject = null;
                newAppDownloadedState.currentIndex = null;
            }

            return newAppDownloadedState;
        case REPORTSUBJECTS_FAILED:
            return {
                ...state,
                pending: false,
                sending: false,
                error: action.payload
            };
        case REPORTSUBJECT_FAILED:
            return {
                ...state,
                pending: false,
                sending: false,
                error: action.payload,
                currentSubject: null,
                currentIndex: 0
            };
        case REPORTSUBJECT_POSTING:
            return {
                ...state,
                sending: true
            };
        case REPORTSUBJECT_EDITING:
            return {
                ...state,
                sending: true
            };
        case REPORTSUBJECT_DELETING:
            return {
                ...state,
                sending: true
            };

        case REPORTSUBJECT_PICTURE_UPLOADING:
            return {
                ...state,
                sending: true
            };
        case REPORTSUBJECT_PICTURE_UPLOADED:
            return {
                ...state,
                sending: false
            };
        case REPORTSUBJECT_PICTURE_FAILED:
            return {
                ...state,
                sending: false,
                error: action.payload
            };
        case REPORTSUBJECT_PICTURE_DELETING:
            return {
                ...state,
                sending: true
            };
        default:
            break;
    }

    return state;
}



// WEBPACK FOOTER //
// src/store/reportsubjects/reducers.js